import { DaoService } from './../servicos/dao.service';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-pesquisa',
  templateUrl: './pesquisa.component.html',
  styleUrls: ['./pesquisa.component.css']
})
export class PesquisaComponent implements OnInit {

  constructor(private dao:DaoService,public messageService: MessageService,private loader: NgxUiLoaderService) { }

  ngOnInit() {
    this.corpo = {
      site:0,
      atendimento:0,
      instalacoes:0

    }
  
  }

  corpo:any;
  votado: boolean = false;

  votar(nota,modalidade){
        
        this.corpo[modalidade]=nota;
  }

  validar(){
    if(this.corpo.site==0){
      this.enviarToast('error','Incompleto','Informe a nota para nosso site.');
      return false;
    }

    if(this.corpo.atendimento==0){
      this.enviarToast('error','Incompleto','Informe a nota para nosso atendimento.');
      return false;
    }

    if(this.corpo.instalacoes==0){
      this.enviarToast('error','Incompleto','Informe a nota para nossas instalações.');
      return false;
    }

    
    if(!this.verificarTempo()){
      this.enviarToast('error','Negado','Você já votou nesta pesquisa, tente novamente mais tarde!');
      return false;
    }

    return true;
  }

  salvarMomento(){
    let agora = Date.now();
    let tempo = {momento:agora};
    localStorage.setItem('momentop',JSON.stringify(tempo));
  }

  verificarTempo(){
    let antes = localStorage.getItem('momentop');
    if(antes){
      let an = JSON.parse(antes)['momento'];
      let duracao = Date.now() - an;
      console.log("Duracao:",duracao);
      if(duracao>600000){
        return true;
      }else{
        return false;
      }
      
    }else{
      return true;
    }
  }

  enviarToast(cor, titulo, texto) {
    this.messageService.add({ severity: cor, summary: titulo, detail: texto });
  }

  enviarPesquisa(){
    if(this.validar()){
      this.loader.start();
      this.dao.submeter(this.corpo,'salvarPesquisa').then(res=>{
        this.loader.stop();
        this.salvarMomento();
        this.votado = true;

      });

    }
  }

}
